var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{attrs:{"fluid":""}},[(_vm.group)?_c('banner-small',{attrs:{"group":_vm.group,"title":"Advanced Event Search"}}):_vm._e(),_vm._v(" "),(_vm.group)?_c('div',[_c('data-table',{attrs:{"actions":_vm.actions,"additional-parameters":_vm.queryParams,"queryName":"AdvancedEvent"},on:{"handleAction":_vm.handleRowAction}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }